/**************************************************
 * Nombre:       Seccion_Prueba
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {AddBoxOutlined, ManageSearch} from '@mui/icons-material'
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_FECHA_DATOS,
    CASILLA_IMG,
    CASILLA_PARRAFO,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useContext} from "react";
import {usuarioContext} from "../../App";
import Dialogo_Colecciones from "../Dialogos/Dialogo_Colecciones";
import Dialogo_Pasarela from "../Dialogos/Dialogo_Pasarela";


const Seccion_Colecciones = () => {
    const usuario = useContext(usuarioContext).usuario
    const {
        props,
        cargarNuevamente,
        numeroFilas
    } = useObtenerColleccionTabla2025({coleccion: 'colecciones'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Colecciones,
        titulo: 'Detalles del reserva',
        realizado: cargarNuevamente
    })


    const click = (id, data) => {
        // console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
        }
    }


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1400px'}}
                spacing={3}
            >

                <Dialogo/>



                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Colecciones'}
                        descripcion={`${numeroFilas} colecciones en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //ComponenteInferior={ExportadorDatos}

                    />
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Seccion_Colecciones

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    }
]


const datosCabecera = [
    {
        nombre: 'Img',
        direccion: 'left',
        propiedad: 'img',
        tipo: CASILLA_IMG

    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['nombre'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS

    },
    {
        nombre: 'descripcion',
        direccion: 'left',
        propiedad: 'descripcion',
        lineas: 2,
        tipo: CASILLA_PARRAFO
    },

    {
        nombre: 'Actual',
        direccion: 'left',
        propiedad: 'actual',
        tipo: CASILLA_TEXTO
    }


]


const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]


